// TODO: Work with BE team to add these to the compatibilities/get_video_call_compatibility endpoint somehow
export const supportedBrowsers = [
  'Chrome',
  'Chromium',
  'Microsoft Edge',
  'Samsung Internet for Android',
]
